import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash';

Vue.use(Vuex);

export interface IStore {
  IsAuthenticated: boolean;
  StationNumber: number | null;
  BallotNumber: number | null;
  FullName: string;
  Lang: string;
  Header: string;
  CommitteeEmail: string;
  FinalCountdown: number;
  ShowCandidateName: boolean;
  ShowCandidatePicture: boolean;
  ShowCandidateDetails: boolean;
  ShowConfirm: boolean;
  ShowPrinter: boolean;
  ShowLanguages: boolean;
  ShowVoterName: boolean;
  AnonymousVoteEnabled: boolean;
  CanCancelVote: boolean;
  ShowSideBar: boolean;
  IsOptions: boolean;
  CandidatesPerRow: number;
  CurrentSubjectIndex: number;
  Subjects: SubjectModel[];
  SaveData: Array<string[] | null>;
  ShowCaptcha: boolean;
  ShowSelectSubject: boolean;
  StartInstructionHTML: string;
  CaptchaKey: string;
}

export default new Vuex.Store<IStore>({
  state: {
    IsAuthenticated: false,
    IsOptions: false,
    StationNumber: null,
    BallotNumber: null,
    FullName: '',
    Lang: '',
    Header: '',
    CommitteeEmail: '',
    FinalCountdown: 0,
    CandidatesPerRow: 6,
    ShowCandidateName: false,
    ShowCandidatePicture: false,
    ShowCandidateDetails: true,
    ShowConfirm: false,
    ShowPrinter: false,
    ShowLanguages: false,
    ShowVoterName: false,
    AnonymousVoteEnabled: false,
    ShowSideBar: true,
    ShowSelectSubject: false,
    StartInstructionHTML: '',
    CanCancelVote: false,
    CurrentSubjectIndex: 0,
    Subjects: [],
    SaveData: [],
    ShowCaptcha: false,
    CaptchaKey: '6LcTaiwUAAAAAHe0dNp8wOqWTRf82v5ThzJqovVj',
  },
  mutations: {
    Init(state, data: ConfigResponse) {
      state.IsAuthenticated = data.IsAuthenticated;
      state.FullName = data.FullName || '';
      state.Lang = data.Lang;
      state.BallotNumber = data.BallotNumber || null;
      state.StationNumber = data.StationNumber || null;
      state.FinalCountdown = data.Countdown || 0;
      state.ShowCandidateName = data.ShowCandidateName;
      state.ShowCandidatePicture = data.ShowCandidatePicture;
      state.ShowCandidateDetails = data.ShowCandidateDetails;
      state.ShowConfirm = data.ShowConfirm;
      state.ShowLanguages = data.ShowLanguages;
      state.ShowVoterName = data.ShowVoterName;
      state.AnonymousVoteEnabled = data.AnonymousVoteEnabled;
      state.ShowSideBar = data.ShowSideBar;
      state.IsOptions = data.IsOptions;
      state.ShowPrinter = data.ShowPrinter;
      state.ShowCaptcha = data.ShowCaptcha;
      state.ShowSelectSubject = data.SelectSubject;
      state.CanCancelVote = data.CanCancelVote;
      state.StartInstructionHTML = data.StartInstructionHTML;

      state.CommitteeEmail = data.CommitteeEmail;
      state.CandidatesPerRow = data.CandidatesCount | 6;
      state.CommitteeEmail = data.CommitteeEmail;
    },
    UnAuthorize(state) {
      state.IsAuthenticated = false;
      state.FullName = '';
      state.StationNumber = null;
      state.BallotNumber = null;
    },
    Login(state, data: VoterLoginResponse) {
      state.IsAuthenticated = true;
      state.FullName = (data.LastName || '') + ' ' + (data.FirstName || '');
    },
    StationLogin(state, data: StationLoginResponse) {
      state.IsAuthenticated = true;
      state.BallotNumber = data.BallotNumber || null;
      state.StationNumber = data.StationNumber || null;
    },
    UpdateName(state, data: { DisplayName: string; ProfileName: string }) {
      state.FullName = data.DisplayName;
      //state.ProfileName = data.ProfileName;
    },

    UpdateLang(state, lang: string) {
      state.Lang = lang;
    },
    Header(state, title: string) {
      state.Header = title;
    },
    SetVotingInfo(state, Subjects: SubjectModel[]) {
      state.CurrentSubjectIndex = 0;
      state.Subjects = Subjects || [];
      state.SaveData = state.Subjects.map((x) => null);
    },
    SelectSubject(state, index: number) {
      index = Number(index);
      if (index == NaN) index = -1;
      state.CurrentSubjectIndex = index;
    },
    SaveSubjectVoting(state, data: { Id: number; Selected: string[] }) {
      var i = Number(data.Id);
      if (i === NaN) i = -1;
      if (i < 0 || i >= state.Subjects.length) return;
      Vue.set(state.SaveData, i, data.Selected || []);
    },
  },
  actions: {},
  modules: {},
  getters: {
    IsFirstSubject(state) {
      return state.CurrentSubjectIndex == 0;
    },
    IsLastSubject(state) {
      return state.CurrentSubjectIndex == state.Subjects.length - 1;
    },
    PrevSubject(state) {
      if (state.CurrentSubjectIndex <= 0) return null;
      if (state.CurrentSubjectIndex > state.Subjects.length) return null;
      return state.Subjects[state.CurrentSubjectIndex - 1].Name || '';
    },
    NextSubject(state) {
      if (state.CurrentSubjectIndex + 1 >= state.Subjects.length) return null;
      if (state.CurrentSubjectIndex < 0) return null;
      return state.Subjects[state.CurrentSubjectIndex + 1].Name || '';
    },
    Subject(state) {
      if (state.CurrentSubjectIndex < 0 || state.CurrentSubjectIndex >= state.Subjects.length) return null;
      const subject = _.cloneDeep(state.Subjects[state.CurrentSubjectIndex]);
      if (subject.HideCandidateFromPrev && state.CurrentSubjectIndex > 0) {
        const prev = state.SaveData[state.CurrentSubjectIndex - 1] || [];
        subject.Candidates = subject.Candidates.filter((c) => !prev.includes(c.Id));
      }
      return subject;
    },
    SubjectData(state) {
      if (state.CurrentSubjectIndex < 0 || state.CurrentSubjectIndex >= state.SaveData.length) return [];
      return state.SaveData[state.CurrentSubjectIndex] || [];
    },
    ConfirmData(state) {
      return state.Subjects.map(
        (x, i): SubjectSimpleModel => {
          let selected = state.SaveData[i];
          let candidates = x.Candidates.filter((c) => selected?.includes(c.Id) || false).map((c) => ({
            Id: c.Id,
            DisplayName: c.DisplayName,
            Enum: c.Enum,
            PictureURL: c.PictureURL,
            PictureURL150x150: c.PictureURL150x150,
            Selected: true,
          }));
          return {
            Id: x.Id,
            Max: x.Max,
            Min: x.Min,
            Name: x.Name,
            WhitePaper: x.WhitePaper,
            Data: selected ? candidates : null,
          };
        },
      );
    },
    SubjectConfirmData(state, getters) {
      if (state.CurrentSubjectIndex < 0 || state.CurrentSubjectIndex >= state.Subjects.length) return null;
      return getters.ConfirmData[state.CurrentSubjectIndex] || [];
    },
  },
});
